import {ComponentProps} from "react";
import {css, cx} from "@panda/css";

import {GalleryOutlineIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {pluralize} from "@pg-mono/string-utils";

interface IProps extends ComponentProps<"div"> {
    photosAmount: number;
}

const galleryImageCountPlural = pluralize(["zdjęcie", "zdjęcia", "zdjęć"]);

export function GalleryCount(props: IProps) {
    const {className, photosAmount, ...rest} = props;

    return (
        <div className={cx(counterHolder, className)} {...rest}>
            <div className={counterHolderIcon}>
                <GalleryOutlineIcon size="2.4" fill="var(--colors-secondary)" />
            </div>

            <Text variant="info_txt_3" align="center" noWrap>
                {photosAmount} {galleryImageCountPlural(photosAmount)}
            </Text>
        </div>
    );
}

const counterHolder = css({
    borderRadius: 0.5,
    padding: 0.5,
    backgroundColor: "var(--colors-success)",
    pointerEvents: "none",
    minWidth: 48,
    minHeight: 48
});

const counterHolderIcon = css({
    marginBottom: 1,
    marginTop: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
import {ComponentProps} from "react";
import {css, cx} from "@panda/css";

import {GalleryOutlineIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {pluralize} from "@pg-mono/string-utils";

interface IProps extends ComponentProps<"div"> {
    photosAmount: number;
}

const galleryImageCountPlural = pluralize(["zdjęcie", "zdjęcia", "zdjęć"]);

export function GalleryCount(props: IProps) {
    const {className, photosAmount, ...rest} = props;

    return (
        <div className={cx(counterHolder, className)} {...rest}>
            <div className={counterHolderIcon}>
                <GalleryOutlineIcon size="2.4" fill="var(--colors-secondary)" />
            </div>

            <Text variant="info_txt_3" align="center" noWrap>
                {photosAmount} {galleryImageCountPlural(photosAmount)}
            </Text>
        </div>
    );
}

const counterHolder = css({
    borderRadius: 0.5,
    padding: 0.5,
    backgroundColor: "var(--colors-success)",
    pointerEvents: "none",
    minWidth: 48,
    minHeight: 48
});

const counterHolderIcon = css({
    marginBottom: 1,
    marginTop: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
